import React from 'react';
import './rules.css';

function C2wRules({ courseData }) {
  return (
    <div className='C2wRules_ctn'>
      <div className='C2wRules_heading'>{'Rules & '}<span>{'Regulations'}</span></div>
      {/* <div className='C2wRules_fee_structure'>{'Total Fee : '}<span>{`Rs. ${courseData?.fees}/- `}</span>{`+${courseData?.gst}% GST`}</div> */}
      {courseData?.type !== 'Offline' ? (
        <ul>
          <li className='C2wRules_fee_structure'>The course offers over <span>{courseData?.courseHours}</span> hours of learning content and is valid for only <span>{courseData?.courseValidity}</span></li>
          <li className='C2wRules_fee_structure'>This course is completely <span>online</span> and only available in <span>recorded mode</span></li>
          <li className='C2wRules_fee_structure1 C2wRules_fee_structure' >All the video lectures will be available only on <span onClick={() => window.open("https://play.google.com/store/apps/details?id=com.developer.core2web2&pcampaignid=web_share")} className='app_url'>core2web mobile app</span> for security purpose</li>
          <li className='C2wRules_fee_structure'>Fees is not refundable & non transferable </li>
          <li className='C2wRules_fee_structure'>Once the validity expires, contact to admin for extension</li>
        </ul>
      ) : (
        <ul>
          <li className='C2wRules_fee_structure'><span>100% Attendance</span> is compulsory for <span>Java</span></li>
          <li className='C2wRules_fee_structure'>No <span>Online</span> video access for <span>Java</span> lectures will be provided</li>
          <li className='C2wRules_fee_structure'>Admission can not be transferred or cancelled under any circumstances</li>
          <li className='C2wRules_fee_structure'><span>Fees non-refundable</span></li>
          <li className='C2wRules_fee_structure'><span>Online</span> video access only for <span>DSA, DBMS, & OS</span>  will be provided</li>
          <li className='C2wRules_fee_structure'>These videos are completely <span>online</span> and only available in <span>recorded mode</span></li>
          <li className='C2wRules_fee_structure' >All the video lectures will be available only on <span onClick={() => window.open("https://play.google.com/store/apps/details?id=com.developer.core2web2&pcampaignid=web_share")} className='app_url'>Core2web mobile app</span> for security purpose</li>

        </ul>
      )
      }
    </div>
  )
}

export default C2wRules
